"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePhoneNumber = exports.resetPasswordInitiate = exports.registerUser = exports.getInstanceAttr = exports.getAccountData = exports.deleteApp = exports.addBusinessPartner = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _cicUtils = require("@eon-funke/cic-utils");
var _mainConfig = _interopRequireDefault(require("../../mainConfig"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getAccountData = exports.getAccountData = function getAccountData() {
  return new Promise(function (resolve) {
    resolve({
      data: _cicUtils.CacheHandler.getCurrentCacheByToken('accountData')
    });
  });
};
var getInstanceAttr = exports.getInstanceAttr = function getInstanceAttr() {
  var stage = {};
  var env = _cicUtils.EnvironmentHelper.getAemInstanceKey();
  if (env && env !== "PROD") {
    stage = {
      aemInstanceKey: env
    };
  }
  return stage;
};
var isOmApp = function isOmApp() {
  var _CONFIG$AEM_CONFIG;
  return !!(_mainConfig.default === null || _mainConfig.default === void 0 ? void 0 : (_CONFIG$AEM_CONFIG = _mainConfig.default.AEM_CONFIG) === null || _CONFIG$AEM_CONFIG === void 0 ? void 0 : _CONFIG$AEM_CONFIG.isOmApp);
};
var getTenantDependentPathPart = function getTenantDependentPathPart() {
  return isOmApp() ? "icon-customer-wl" : "icon-customer";
};
var registerUser = exports.registerUser = function registerUser(dataObj, config) {
  return _cicUtils.RestHelper.post("".concat(_cicUtils.RestHelper.getBaseUrl(_cicUtils.MWDomains.account), "/public-api/v1/accounts"), dataObj, config, true, false);
};
var resetPasswordInitiate = exports.resetPasswordInitiate = function resetPasswordInitiate(emailDataObj, config) {
  return _cicUtils.RestHelper.post("".concat(_cicUtils.RestHelper.getBaseUrl(_cicUtils.MWDomains.account), "/public-api/").concat(getTenantDependentPathPart(), "/v1/accounts/resetpassword"), emailDataObj, config, true, false);
};
var validatePhoneNumber = exports.validatePhoneNumber = function validatePhoneNumber(phoneNumber) {
  // eslint-disable-next-line prefer-regex-literals
  var pattern = new RegExp('^(\\+[1-9]|[0-9])[\\d\\s\\-]+$');
  if (!pattern.test(phoneNumber) || phoneNumber.length > 18) {
    var data = {
      errors: [{}]
    };
    return Promise.resolve({
      data: data
    });
  }
  return _cicUtils.RestHelper.post("".concat(_cicUtils.RestHelper.getBaseUrl(_cicUtils.MWDomains.account), "/public-api/v1/validations/phonenumber"), {
    data: {
      type: 'ValidationResource',
      attributes: {
        toBeValidate: phoneNumber
      }
    }
  }, {}, true, false);
};
var deleteApp = exports.deleteApp = function deleteApp(payload) {
  var promise = _cicUtils.RestHelper.post("".concat(_cicUtils.RestHelper.getBaseUrl(_cicUtils.MWDomains.account), "/api/").concat(getTenantDependentPathPart(), "/v1/accounts/delete"), {
    data: {
      id: _cicUtils.CacheHandler.getCurrentCacheByToken('accountData').id,
      type: 'AccountDeactivationResource',
      attributes: _objectSpread({
        dso: _mainConfig.default.AEM_CONFIG.siteVariable
      }, payload)
    }
  });
  promise.then(function () {
    if (payload.applicationKeys) {
      var oldCache = _cicUtils.CacheHandler.getCurrentCacheByToken('accountData');
      var apps = oldCache.apps.filter(function (app) {
        return !payload.applicationKeys.find(function (deletedApp) {
          return deletedApp === app;
        });
      });
      var current = _objectSpread(_objectSpread({}, oldCache), {
        apps: apps
      });
      _cicUtils.CacheHandler.saveCache({
        accountData: current
      });
    }
  });
  return promise;
};
var addBusinessPartner = exports.addBusinessPartner = function addBusinessPartner(partnerData) {
  return _cicUtils.RestHelper.post("".concat(_cicUtils.RestHelper.getBaseUrl(), "/grid/cscn-customer-srv/api/useraccount/v0/businesspartners"), partnerData, {}, true, true);
};